jQuery(document).ready( function() {
  //Add and remove class on scroll for header transparency
  jQuery(window).on("scroll", function() {
    if(jQuery(window).scrollTop() > 16) {
      jQuery('header').removeClass('pursuit_header_change');
    } else {
      jQuery('header').addClass('pursuit_header_change');
    }
  });
  //Scroller arrow link on the home page hero section
  jQuery("#scrollerDown").on("click touchstart", function(e) {
    e.preventDefault();
    jQuery("html, body").animate({
      scrollTop: jQuery("#scrollerDown").offset().top
    }, 1400);
  });
  //Make top level Bootstrap nav clickable, even with dropdown
  jQuery('#pursuit_main_nav a.dropdown-toggle').on( "click", function() {
    location.href = jQuery(this).attr('href');
  });
  //Hamburger menu opener
  jQuery(".hamburger").on("click touch", function() {
    jQuery(".hamburger").toggleClass("is-active");
    jQuery(".hamMenuBlock").removeClass("hamMenuStart");
    jQuery(".hamMenuBlock").toggleClass("hamMenuBlockOpen");
    jQuery(".hamMenuBlock").toggleClass("hamMenuBlockClose");
    jQuery("body").toggleClass("scrollStopper");
    if (jQuery(".hamMenuBlock").hasClass("hamMenuBlockClose")) {
      jQuery(".hamMenuBlock").delay(700).queue(function(next){
        jQuery(".hamMenuBlock").addClass("hamMenuStart");;
        next();
      });
    }
  });
  //Hamburger menu sub menus
  jQuery('.hamMenuLinkSubArrow').on('click', function(){
    var thisAnswer = jQuery(this).parent().nextAll('.hamMenuLinkMainSubBlock').first();
    var thisQuestion = jQuery(this).parent();
    jQuery('.hamMenuLinkMainSubBlock').not(thisAnswer).slideUp('fast');
    jQuery(thisAnswer).slideToggle('fast');
    jQuery(thisQuestion).toggleClass('hamMenuLinkMainActive');
    jQuery('.hamMenuLinkSubArrow').not(this).removeClass('hamMenuLinkSubArrowUp');
    jQuery(this).toggleClass('hamMenuLinkSubArrowUp');
  });
  //
  jQuery('.dropdown-menu').hover(function(){
    var thisMain = jQuery(this).prev().find('span');
    jQuery(this).prev().find('span').addClass("nav-link__active");
  }, function () {
    jQuery(this).prev().find('span').removeClass("nav-link__active");
  });
});
